import { Col, Form, Modal, Row } from 'react-bootstrap'
import { CustomButton } from '../../components/CustomButton'
import { ArrowRight, CheckCircle, Play } from 'phosphor-react'
import { useState } from 'react'
import { CustomIntegerInput } from '../../components/CustomDecimalInput'
import { formatPrice } from '../../utils/formatPrice'
import { sendErrorApiMessage } from '../../utils/sendErrorApiMessage'
import apinode from '../../services/apinode'
import { toast } from 'react-toastify'

export function ModalAjustarPrecos({ isOpen, onClose, products, reset }) {
  const [percentage, setPercentage] = useState('')
  const [result, setResult] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  async function handleSubmit() {
    try {
      setIsLoading(true)

      await apinode.patch(`/custos-porcentagem/${localStorage.idconta}`, result)

      toast.success('Custos atualizados com sucesso!')

      onClose()

      reset()
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao atualizar o custo')
    } finally {
      setIsLoading(false)
    }
  }

  function calculatePercentage() {
    setResult([])

    for (const product of products) {
      const perc = Number(percentage)
      const custoCent = product.PRECOCUSTO / 100
      const additional = (custoCent * perc) / 100
      const newVendaCent = custoCent + additional
      const preco_venda = Number(product.PRECOVENDA)
      const preco_custo = Number(product.PRECOCUSTO)
      const novo_precovenda = Number((newVendaCent * 100).toFixed(2))

      const status =
        novo_precovenda > preco_venda
          ? 'up'
          : novo_precovenda < preco_venda
            ? 'down'
            : 'same'

      setResult((pv) => [
        ...pv,
        {
          sku: product.SKU,
          preco_venda,
          novo_precovenda,
          status,
          preco_custo,
        },
      ])
    }
  }

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      centered
    >
      <Modal.Header>
        <Modal.Title>Ajustar Preços</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Row>
          <Col xs="auto">
            <div
              style={{
                display: 'flex',
                alignItems: 'flex-end',
              }}
            >
              <div>
                <Form.Label>Aplicar %</Form.Label>

                <CustomIntegerInput
                  value={percentage}
                  onChange={(e) => setPercentage(e.target.value)}
                />
              </div>

              <CustomButton
                isDisabled={!percentage}
                onClick={calculatePercentage}
              >
                <Play
                  size={15}
                  weight="fill"
                />
              </CustomButton>
            </div>
          </Col>
        </Row>

        {result.length > 0 && (
          <section
            style={{
              margin: 5,
              minWidth: '100%',
              maxHeight: 250,
              overflow: 'auto',
            }}
          >
            {result.map((re) => (
              <ul>
                <hr />

                <li>
                  <div
                    style={{
                      minWidth: '100%',
                      display: 'flex',
                      gap: 5,
                      alignItems: 'center',
                    }}
                  >
                    <strong>{re.sku}:</strong>
                    <>{formatPrice(re.preco_custo)}</>

                    <ArrowRight size={20} />

                    <span>{formatPrice(re.preco_venda)}</span>

                    <ArrowRight size={20} />

                    <span
                      style={{
                        color:
                          re.status === 'up'
                            ? 'green'
                            : re.status === 'down'
                              ? 'red'
                              : '',
                      }}
                    >
                      {formatPrice(re.novo_precovenda)}
                    </span>
                  </div>
                </li>
              </ul>
            ))}
          </section>
        )}
      </Modal.Body>

      <Modal.Footer>
        <CustomButton
          isDisabled={!result.length}
          title="Confirmar"
          onClick={handleSubmit}
          isLoading={isLoading}
          isLoadingText="Confirmando..."
        >
          <CheckCircle
            weight="fill"
            size={20}
          />
        </CustomButton>
      </Modal.Footer>
    </Modal>
  )
}
